import {ContractTypes} from 'utility/utility'
import {object, string} from 'yup'

export const ResellerSchema = object().shape({
  name: string().max(255, 'Name too long!').required('Name is required!'),
  address: string().max(512, 'Address too long!'),
  postalCode: string().max(20, 'Postal code is too long!'),
  phone: string().max(20, 'Phone number too long!'),
  accountNumber: string().max(20, 'Account number too long!').optional(),
  contractType: string().required('Contract type is required'),
  distributor: string().optional(),
  trialExpiry: string().when('contractType', {
    is: value => value === ContractTypes.Trial,
    then: () => string().required('Trial expiry date is required!')
  }),
  contractExpiry: string().when('contractType', {
    is: value => value === ContractTypes.Customer,
    then: () => string().required('Contract expiry date is required!')
  })
})

export const ResellerPrototype = {
  name: '',
  address: '',
  postalCode: '',
  phone: '',
  accountNumber: '',
  distributor: '',
  contractType: ContractTypes.Trial,
  trialExpiry: '',
  contractExpiry: ''
}
